import { z } from 'zod';
import { ZoneSchema } from './types';


export class ZoneListErrorTypes {
    public static readonly INTERSECTION = 'intersection';
    public static readonly NOT_A_POLYGON = 'not-a-polygon';
    public static readonly SELF_INTERSECTION = 'self-intersection';
    public static readonly ZONE_TOO_BIG = 'zone-too-big';
}

export const ZoneListErrorSchema = z.object({
    uniqueId: z.string().describe('unique identifier of error to exclude duplicated overvalps (a>b, b<a)'),
    description: z
        .string()
        .describe(
            'array of errors as keys to translate or something else ex:   ' +
                '  "zone-editor-conflict-intersection": "Strefa {zone} nakłada się na inne."' +
                '  "zone-editor-conflict-not-a-polygon": "Strefa {zone} jest niepoprawna."' +
                '  "zone-editor-conflict-self-intersection": "Strefa {zone} zawiera samoprzecięcia.' +
                '  "zone-editor-conflict-zone-too-big": "Strefa {zone} jest zbyt rozległa.'
        ),
    type: z.string().describe('intersection|not-a-polygon|self-intersection|zone-too-big'),
    zoneId: z.string().nullable().catch(null),
    details: z.any().optional(),
    timestamp: z.number().optional()
});
export type ZoneListErrorType = z.infer<typeof ZoneListErrorSchema>;

export const ZoneListConflictSchema = z.object({
    zone: ZoneSchema,
    conflicts: z.object({
        errors: z.array(
            z.object({
                type: z.string(),
                markable: z.boolean().catch(false),
                zoneId: z.number().optional()
            })
        ),
    }),
});
export type ZoneListConflictType = z.infer<typeof ZoneListConflictSchema>;
